"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = _interopRequireDefault(require("immutable"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UIIconRating = _interopRequireDefault(require("UIComponents/input/UIIconRating"));

var _UIDropdownSelect = _interopRequireDefault(require("UIComponents/dropdown/UIDropdownSelect"));

var _ReviewCard = _interopRequireDefault(require("../components/ReviewCard"));

var _ReviewListZeroState = _interopRequireDefault(require("../components/ReviewListZeroState"));

var _goodDetails = require("../selectors/goodDetails");

var _utils = require("../utils/utils");

var getI18nKey = function getI18nKey(path) {
  return "goodDetails.reviewList." + path;
};

var MAX_INITIAL_REVIEWS = 6;
var SortDirections = Object.freeze((0, _keyMirror.default)({
  NEWEST_OLDEST: null,
  OLDEST_NEWEST: null,
  HIGHEST_LOWEST: null,
  LOWEST_HIGHEST: null
}));

var ReviewList = _react.default.createClass({
  displayName: "ReviewList",
  propTypes: {
    averageRating: _propTypes.default.number.isRequired,
    canReview: _propTypes.default.bool.isRequired,
    reviews: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
    triggerReviewModal: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    var reviews = this.props.reviews;
    return {
      showAllReviews: reviews.size <= MAX_INITIAL_REVIEWS,
      sortDirection: SortDirections.NEWEST_OLDEST
    };
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var showAllReviews = this.state.showAllReviews;
    var reviews = this.props.reviews;
    var nextReviews = nextProps.reviews;

    if (!showAllReviews && reviews.size !== nextReviews.size) {
      this.setState({
        showAllReviews: nextReviews.size <= MAX_INITIAL_REVIEWS
      });
    }
  },
  handleShowAllReviews: function handleShowAllReviews() {
    this.setState({
      showAllReviews: true
    });
  },
  getSortedReviews: function getSortedReviews() {
    var reviews = this.props.reviews;
    var _this$state = this.state,
        showAllReviews = _this$state.showAllReviews,
        sortDirection = _this$state.sortDirection;
    var sortedReviews = reviews;

    switch (sortDirection) {
      case SortDirections.NEWEST_OLDEST:
      case SortDirections.OLDEST_NEWEST:
        {
          sortedReviews = reviews.sortBy(function (review) {
            var updatedAt = review.get('updatedAt');
            return sortDirection === SortDirections.NEWEST_OLDEST ? -updatedAt : updatedAt;
          });
          break;
        }

      case SortDirections.HIGHEST_LOWEST:
      case SortDirections.LOWEST_HIGHEST:
        {
          sortedReviews = reviews.sortBy(function (review) {
            var rating = review.get('rating');
            return sortDirection === SortDirections.HIGHEST_LOWEST ? -rating : rating;
          });
          break;
        }

      default:
        break;
    }

    if (!showAllReviews) {
      sortedReviews = sortedReviews.take(MAX_INITIAL_REVIEWS);
    }

    return sortedReviews;
  },
  handleSortingChange: function handleSortingChange(event) {
    this.setState({
      sortDirection: event.target.value
    });
  },
  renderReviewCard: function renderReviewCard(review, index) {
    return _react.default.createElement(_UIGridItem.default, {
      size: {
        xs: 12,
        md: 4
      },
      key: index
    }, _react.default.createElement(_ReviewCard.default, {
      company: review.get('company'),
      rating: review.get('rating'),
      reviewDate: review.get('updatedAt'),
      reviewText: review.get('contents'),
      userAvatarUrl: review.get('avatarUrl'),
      userFullName: review.get('fullName')
    }));
  },
  renderReviewButton: function renderReviewButton(triggerReviewModal) {
    return _react.default.createElement(_UIButton.default, {
      className: "m-left-4",
      onClick: triggerReviewModal,
      size: "small",
      use: "primary"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('reviewThisProduct')
    }));
  },
  renderSortingDropdown: function renderSortingDropdown() {
    var selectedSortDirection = this.state.sortDirection;
    var options = Object.keys(SortDirections).map(function (sortDirection) {
      return {
        text: (0, _unescapedText.default)(getI18nKey("sortingOptions." + sortDirection)),
        value: sortDirection
      };
    });
    return _react.default.createElement(_UIDropdownSelect.default, {
      buttonUse: "link",
      onChange: this.handleSortingChange,
      options: options,
      value: selectedSortDirection
    });
  },
  renderSectionHeader: function renderSectionHeader(reviews, averageRating, isAbleToReview, triggerReviewModal) {
    var showAllReviews = this.state.showAllReviews;
    var totalCount = reviews.size;
    var columnSizes = {
      xs: 12,
      md: 6
    };
    var renderedShowingText = showAllReviews ? _react.default.createElement(_FormattedHTMLMessage.default, {
      message: getI18nKey('showing.all'),
      options: {
        totalCount: totalCount
      }
    }) : _react.default.createElement(_FormattedHTMLMessage.default, {
      message: getI18nKey('showing.initial'),
      options: {
        count: MAX_INITIAL_REVIEWS,
        totalCount: totalCount
      }
    });
    return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
      size: columnSizes
    }, _react.default.createElement("span", {
      className: "is--heading-7 display-inline"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('header')
    })), _react.default.createElement(_UIIconRating.default, {
      className: "display-inline m-left-4",
      defaultValue: averageRating,
      disabled: true,
      iconSize: "xxs",
      showPercentage: true
    }), _react.default.createElement("span", {
      className: "m-left-1"
    }, "(", totalCount, ")"), isAbleToReview && this.renderReviewButton(triggerReviewModal)), _react.default.createElement(_UIGridItem.default, {
      className: "text-right",
      size: columnSizes
    }, this.renderSortingDropdown(), _react.default.createElement("span", {
      className: "m-left-10"
    }, renderedShowingText))));
  },
  render: function render() {
    var _this$props = this.props,
        averageRating = _this$props.averageRating,
        canReview = _this$props.canReview,
        reviews = _this$props.reviews,
        triggerReviewModal = _this$props.triggerReviewModal;
    var showAllReviews = this.state.showAllReviews;
    var showZeroState = (0, _utils.isBelowMinimumRequiredReviews)(reviews.size);
    var sortedReviews = this.getSortedReviews();
    return _react.default.createElement(_UISection.default, null, !showZeroState && this.renderSectionHeader(reviews, averageRating, canReview, triggerReviewModal), showZeroState ? _react.default.createElement(_ReviewListZeroState.default, {
      isAbleToReview: canReview,
      triggerReviewModal: triggerReviewModal
    }) : _react.default.createElement(_UIGrid.default, null, sortedReviews.map(this.renderReviewCard), !showAllReviews && _react.default.createElement(_UIGridItem.default, {
      className: "text-center",
      size: 12
    }, _react.default.createElement(_UIButton.default, {
      onClick: this.handleShowAllReviews,
      use: "link"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('viewAllReviews')
    })))));
  }
});

var select = function select(state) {
  return {
    averageRating: state.goodDetails.get('averageRating'),
    canReview: (0, _goodDetails.getCanReview)(state),
    reviews: state.goodDetails.get('reviews')
  };
};

var ReviewListContainer = (0, _reactRedux.connect)(select)(ReviewList);
var _default = ReviewListContainer;
exports.default = _default;
module.exports = exports.default;